import Stack from "components/Stack";
import Text from "components/Text";

import { IPackageDetailsField } from "entities/Checklist/sdk";

export interface IPrintableMemoFieldTitle {
  field: IPackageDetailsField;
  disabled?: boolean;
}

const PrintableMemoFieldTitle = ({
  field,
  disabled = false,
}: IPrintableMemoFieldTitle) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    marginRight={4}
    flexBasis="400px"
    sx={{
      maxWidth: "60%",
      flexGrow: 1,
    }}
  >
    <Text
      variant="text2"
      sx={{
        fontWeight: "500",
        opacity: field.n_a_status || disabled ? 0.5 : 1,
      }}
      data-testid="field-name"
    >
      {field.name}
    </Text>
  </Stack>
);

export default PrintableMemoFieldTitle;
